<template>
    <div class="fuwu-information">
      <div class="common-header-wrap">
        <mt-header :title="(mode=='edit'?'编辑':'添加')+'服务'" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
      <div class="user-avatar iconfont icon-xiangji" ref="upload_btn" @change="uploadImage('goods_image',$event)">
        <img :src="goodsImageUrl">
        <input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg">
      </div>
      <div class="form main-content">
		<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">服务名称</span><div class="field-line-right" slot="right"><input class="field-input" v-model="goods.o2o_fuwu_goods_name" /></div></flex-line>
		<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">广告词</span><div class="field-line-right" slot="right"><input class="field-input" v-model="goods.o2o_fuwu_goods_advword" /></div></flex-line>

        <div @click="classVisible=true">
			<flex-line class="menu-item" :is-link="true" :show-border="true"><span class="field-line field-name">服务分类</span><div class="field-line-right" slot="right"><span>{{goods.o2o_fuwu_class_name}}</span></div></flex-line>
        </div>
        <div @click="specVisible=true">
			<flex-line class="menu-item" :is-link="true" :show-border="true"><span class="field-line field-name">服务项目</span><div class="field-line-right" slot="right"><span>{{(defaultPrice?(defaultPrice+'元'):'')+(specQuantity>1?'起':'')}}</span></div></flex-line>
        </div>
        <div @click="bodyVisible=true">
			<flex-line class="menu-item" :is-link="true" :show-border="true"><span class="field-line field-name">服务描述</span><div class="field-line-right" slot="right"><span>{{(bodyList.length>1 || bodyList[0].value)?'已编辑':'待编辑'}}</span></div></flex-line>
        </div>
		<div class="common-btn mint-button--primary ds-button-large mt-10" @click='submitInformation'>保存</div>
      </div>

      <!--服务分类-->
      <mt-popup v-model="classVisible" position="bottom">
        <mt-picker ref="class_picker" :slots="buildItems" valueKey="o2o_fuwu_class_name" @change="onClassChange" showToolbar>
          <div class="toolbar">
            <button class="toolbar-item cancel-item" @click="cancelClass">取消</button>
            <div class="picker-header">选择分类</div>
            <button class="toolbar-item confirm-item" @click="confirmClass">确定</button>
          </div>
        </mt-picker>
      </mt-popup>

      <!--服务项目-->
      <mt-popup v-model="specVisible" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="服务项目" class="common-header">
            <mt-button slot="left" icon="back" @click="getMinPrice"></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <div class="spec-list" v-for="(item,index) in specList">
            <div class="spec-item menu-item main-content">
				<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">项目名称</span><div class="field-line-right" slot="right"><input class="field-input" v-model="item.o2o_fuwu_goods_spec_name" /></div></flex-line>
				<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">单位</span><div class="field-line-right" slot="right"><input class="field-input" v-model="item.o2o_fuwu_goods_spec_unit" /></div></flex-line>
				<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">价格</span><div class="field-line-right" slot="right"><input class="field-input" v-model="item.o2o_fuwu_goods_spec_price" /></div></flex-line>
				<flex-line :show-border="true">
					<span>类型</span>
					<div slot="right">
						<mt-radio
								v-model="item.o2o_fuwu_goods_spec_type"
								:options="specTypeOptions">
						</mt-radio>
					</div>
				</flex-line>
				<div v-show="index!=(specList.length-1)" class="common-btn mint-button--primary ds-button-large mt-10" @click='delSpec(index)'>删除</div>
            </div>
          </div>
		  <div class="common-btn mint-button--primary ds-button-large mt-10" @click="addSpec">新增</div>
        </div>
      </mt-popup>

      <!--服务描述-->
      <mt-popup v-model="bodyVisible" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="服务描述" class="common-header">
            <mt-button slot="left" icon="back" @click="bodyVisible=false"></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <div class="body-list">
            <div class="body-item" v-for="(item,index) in bodyList" :key='index'>
              <div v-if="item.type=='text'">{{item.value?item.value:'请输入内容'}}</div>
              <div v-if="item.type=='image'"><img v-if="item.value" :src="item.value_url"><span v-else>{{请上传图片}}</span></div>
              <div class="btn-list">
                <!--上移-->
                <i class="iconfont" v-show="index!=0" @click="bodyMove(index,'up')">&#xe648;</i>
                <!--下移-->
                <i class="iconfont" v-show="index!=(bodyList.length-1)" @click="bodyMove(index,'down')">&#xe643;</i>
                <!--插入-->
                <i class="iconfont" @click="bodyAdd(index)">&#xe69c;</i>
                <!--编辑-->
                <i class="iconfont" @click="bodyEdit(index,item)">&#xe658;</i>
                <!--删除-->
                <i class="iconfont" v-show="index!=(bodyList.length-1)" @click="bodyDel(index)">&#xe641;</i>
              </div>
            </div>
          </div>

        </div>
      </mt-popup>
      <!--服务描述编辑-->
      <mt-popup
        class="middle-popup"
        v-model="bodyEditVisible"
        popup-transition="popup-fade">
				<flex-line class="menu-item" :show-border="true"><span class="field-line field-name">请输入内容</span><div class="field-line-right" slot="right"><input class="field-input" type="textarea" v-model="bodyItem.value" /></div></flex-line>
                <div v-if="bodyItem.type=='image'" class="user-avatar iconfont icon-xiangji" ref="upload_btn" @change="uploadImage('goods_body',$event)">
                  <img :src="bodyItem.value_url">
                  <input type="file" accept="image/jpg,image/png,image/gif,image/bmp,image/jpeg">
                </div>

      </mt-popup>
      <!--服务描述新增-->
      <mt-popup
        class="middle-popup fuwu-information-middle-popup-bodytype"
        v-model="bodyAddVisible"
        popup-transition="popup-fade">
				<flex-line :show-border="true">
					<span>类型</span>
					<div slot="right">
						<mt-radio
								v-model="bodyType"
								:options="bodyTypeOptions">
						</mt-radio>
					</div>
				</flex-line>

        <div class="btn-wrapper">

            <mt-button class="btn" type="default" @click="bodyAddVisible=false">取消</mt-button>
            <mt-button class="btn" type="primary" @click='confirmBodyAdd'>确定</mt-button>
          </div>
      </mt-popup>
    </div>
</template>

<script>

import { Toast } from 'mint-ui'
import { uploadInfoFile } from '../../../api/fuwuManageInfo'
import { getClassTree } from '../../../api/fuwuClass'
import { getGoodsInfo, editGoods, addGoods } from '../../../api/fuwuManageGoods'
import flexLine from '../../flexLine'
export default {
  components: {
	flexLine
  },
  name: 'FuwuManageGoodsForm',
  data () {
    return {
      goods: {},
      mode: this.$route.query.action,
      o2o_fuwu_goods_id: this.$route.query.o2o_fuwu_goods_id ? this.$route.query.o2o_fuwu_goods_id : 0,
      goodsImage: '',
      goodsImageUrl: '',
      defaultPrice: '',
      specQuantity: 0,
      classVisible: false,
      items: false,
      specVisible: false,
      specTypeOptions: [
        {
          label: '默认服务',
          value: '0'
        },
        {
          label: '增值服务',
          value: '1'
        }
      ],
      specList: [{
        o2o_fuwu_goods_spec_id: 0,
        o2o_fuwu_goods_spec_unit: '',
        o2o_fuwu_goods_spec_name: '',
        o2o_fuwu_goods_spec_type: '0',
        o2o_fuwu_goods_spec_price: ''
      }],
      bodyVisible: false,
      bodyIndex: 0,
      bodyList: [{
        type: 'text',
        value: ''
      }
      ],
      bodyItem: false,
      bodyEditVisible: false,
      bodyAddVisible: false,
      bodyTypeOptions: [
        {
          label: '文字',
          value: 'text'
        },
        {
          label: '图片',
          value: 'image'
        }
      ],
      bodyType: 'text'
    }
  },
  mounted () {

  },

  computed: {

    buildItems: function () {
      if (!this.items) {
        return []
      }
      let items = new Array()

      this.getDefaultItems(this.items, items)
      return items
    }
  },
  created: function () {
    getClassTree().then(res => {
      this.items = res.result.o2o_fuwu_class_list
    })
    if (this.mode == 'edit') {
      getGoodsInfo(this.o2o_fuwu_goods_id).then(res => {
        this.goods = res.result.o2o_fuwu_goods_info
        this.defaultPrice = this.goods.o2o_fuwu_goods_default_price
        this.specQuantity = this.goods.o2o_fuwu_goods_spec_quantity
        if (this.goods.o2o_fuwu_goods_body) {
          this.bodyList = this.goods.o2o_fuwu_goods_body
        }
        this.goodsImage = this.goods.o2o_fuwu_goods_image
        this.goodsImageUrl = this.goods.o2o_fuwu_goods_image_url
        this.specList = res.result.o2o_fuwu_goods_spec_list
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },

  methods: {
    getMinPrice () {
      let min_price = false
      let quantity = 0
      if (this.specList.length) {
        for (var i in this.specList) {
          if (this.specList[i].o2o_fuwu_goods_spec_type == '0') {
            quantity++
            if (min_price === false || min_price > this.specList[i].o2o_fuwu_goods_spec_price) {
              min_price = this.specList[i].o2o_fuwu_goods_spec_price
            }
          }
        }
      }
      if (min_price !== false) {
        this.defaultPrice = min_price
      } else {
        this.defaultPrice = ''
      }
      this.specQuantity = quantity
      this.specVisible = false
    },
    bodyDel (index) {
      this.bodyList.splice(index, 1)
    },
    bodyMove (index, mode) {
      if (mode == 'up') {
        this.bodyList.splice(index - 1, 2, this.bodyList[index], this.bodyList[index - 1])
      } else {
        this.bodyList.splice(index, 2, this.bodyList[index + 1], this.bodyList[index])
      }
    },
    confirmBodyAdd () {
      let bodyItem = { type: this.bodyType, value: '' }
      this.bodyList.splice(this.bodyIndex, 0, bodyItem)
      this.bodyAddVisible = false
      this.bodyEdit(this.bodyIndex, bodyItem)
    },
    bodyAdd (index) {
      this.bodyAddVisible = true
      this.bodyIndex = index
    },
    bodyEdit (index, item) {
      this.bodyEditVisible = true
      this.bodyItem = item
    },
    delSpec (index) {
      this.specList.splice(index, 1)
    },
    addSpec () {
      this.specList.push({
        o2o_fuwu_goods_spec_id: 0,
        o2o_fuwu_goods_spec_unit: '',
        o2o_fuwu_goods_spec_name: '',
        o2o_fuwu_goods_spec_type: '0',
        o2o_fuwu_goods_spec_price: ''
      })
    },
    getDefaultItems (_item, defaultItems) {
      if (_item[0].child && _item[0].child.length > 0) {
        let index = 1
        if (defaultItems && defaultItems.length == 0) {
          defaultItems.push({
            flex: 1,
            values: _item,
            textAlign: 'center'

          })
          this.getDefaultItems(_item, defaultItems)
        } else if (defaultItems && defaultItems.length > 0) {
          defaultItems.push({
            flex: 1,
            values: _item[0].child,
            textAlign: 'center'

          })
          this.getDefaultItems(_item[0].child, defaultItems)
        }
      }
    },

    cancelClass () {
      this.classVisible = false
    },
    confirmClass () {
      let values = this.$refs.class_picker.getValues()
        let value=values[1]?values[1]:values[0]
      this.goods.o2o_fuwu_class_name = value.o2o_fuwu_class_name
      this.goods.o2o_fuwu_class_id = value.o2o_fuwu_class_id
      this.goods.o2o_fuwu_class_id_1 = values[0].o2o_fuwu_class_id
      this.goods.o2o_fuwu_class_id_2 = 0
      if (values[1]) {
        this.goods.o2o_fuwu_class_id_2 = values[1].o2o_fuwu_class_id
      }
      this.classVisible = false
    },
    onClassChange (picker, values) {
      picker.setSlotValues(1, values[0] ? values[0].child : [])
      picker.setSlotValues(2, values[1] ? values[1].child : [])
    },
    submitInformation () {
      this.goods.o2o_fuwu_goods_image = this.goodsImage
      if (this.mode == 'edit') {
        editGoods(this.o2o_fuwu_goods_id, this.goods, this.bodyList, this.specList).then(res => {
          Toast(res.message)
          this.$router.push({ name: 'FuwuManageGoodsList' })
        }).catch(function (error) {
          Toast(error.message)
        })
      } else {
        addGoods(this.goods, this.bodyList, this.specList).then(res => {
          Toast(res.message)
          this.$router.push({ name: 'FuwuManageGoodsList' })
        }).catch(function (error) {
          Toast(error.message)
        })
      }
    },
    uploadImage (type, event) {
      if (typeof (event.target.files[0]) === 'undefined') {
        return
      }
      let formdata = new FormData()

      formdata.append('file', event.target.files[0])
      formdata.append('type', type)
      formdata.append('item_id', this.o2o_fuwu_goods_id)
      if (type == 'goods_body' && this.bodyItem.value) {
        formdata.append('path', this.bodyItem.value)
      } else if (type == 'goods_image' && this.goods.o2o_fuwu_goods_image) {
        formdata.append('path', this.goods.o2o_fuwu_goods_image)
      }
      uploadInfoFile(formdata).then(res => {
        if (type == 'goods_image') {
          this.goodsImage = res.result.path
          this.goodsImageUrl = res.result.url
        } else {
          this.bodyItem.value = res.result.url
          this.bodyItem.value_url = res.result.url
          this.bodyEditVisible = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style>
	.fuwu-information-middle-popup-bodytype .flex-line .left{margin-left: 2.6rem;}
</style>
<style  lang="scss" scoped>
	.main-content{background: #fff;padding:0 $pageSpace}
  .fuwu-information {
    background: #fff;
    .user-avatar {
      position: relative;
      width: 5rem;
      height: 5rem;
      margin: 2rem auto;
      text-align: center;
      img {
        width: 100%;
        height: 100%
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0
      }
    }
    .user-avatar::before {
      position: absolute;
      font-size: 1.5rem;
      line-height: 5rem;
      left: 50%;
      margin-left: -.75rem;
      color: rgba(0, 0, 0, 0.5)
    }
    .toolbar {
      height: 2rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: stretch;
      background-color: #f0f2f5;
      .toolbar-item {
        font-size: .6rem;
        border: none;
        border-radius: 0;
        background-color: #f0f2f5;
      }
      .cancel-item {
        margin-left: 0.5rem;
        color: #4e545d;
      }
      .confirm-item {
        margin-right: 0.5rem;
        color: red;
      }
      .picker-header {
        color: #4e545d;
        line-height: 2rem;
        font-size:.8rem;
      }
    }
    .btn-wrapper{display:flex;
      .btn{flex:1}
    }
    .mint-radiolist {
      display: flex;
      .mint-cell {
        flex: 1;
        .mint-radio-input:checked + .mint-radio-core {
          background-color: #ff9900 !important;
          border-color: #ff9900 !important;
        }
      }
    }
    .body-list{
      .body-item{padding:1rem;position:relative;min-height:2.2rem;font-size:.6rem;
        img{max-width:100%}
        .btn-list{text-align:right;background:rgba(0,0,0,.5);position:absolute;top:.5rem;bottom:.5rem;left:.5rem;right:.5rem;padding:.5rem;box-sizing:border-box;
          i{font-size:1.2rem;margin-left:.5rem;color:#fff;}
        }
      }
    }
    .middle-popup{width:80%}
  }

</style>
